import {
  ChakraBox,
  DateFormat,
  EmptySectionCard,
  OutOfOfficeListItemCard,
  SkeletonLoader,
  getOutOfOfficeDateStatus,
} from '@equip.health/ui';
import { isEmpty } from 'lodash';

import { formattedDateFromISO } from '../../../lib/util/date.util';

const TOP_LEVEL_ID = 'out-of-office__list';

interface OutOfOfficeScheduleListProps {
  listItems: OutOfOfficeItem[];
  isLoading: boolean;
  onCardClick: (id: string) => void;
}

const OutOfOfficeScheduleList = ({
  listItems,
  isLoading,
  onCardClick,
}: OutOfOfficeScheduleListProps) => {
  if (isEmpty(listItems)) {
    return (
      <SkeletonLoader id={TOP_LEVEL_ID} isLoaded={!isLoading}>
        <EmptySectionCard
          caption="There are no current or upcoming out of offices"
          id={`${TOP_LEVEL_ID}__empty-card`}
        />
      </SkeletonLoader>
    );
  }

  return (
    <ChakraBox>
      <SkeletonLoader id={TOP_LEVEL_ID} isLoaded={!isLoading}>
        <ChakraBox display="flex" flexDirection="column" gap="12px">
          {listItems?.map((item) => {
            const { startDate, endDate, outOfOfficeId } = item;
            const status = getOutOfOfficeDateStatus(startDate, endDate);

            const formattedStartDate = formattedDateFromISO(
              startDate,
              DateFormat.shortMonthDayYear,
            );

            const formattedEndDate = formattedDateFromISO(
              endDate,
              DateFormat.shortMonthDayYear,
            );

            const dateRange = `${formattedStartDate} - ${formattedEndDate}`;

            return (
              <OutOfOfficeListItemCard
                dateRange={dateRange}
                id={outOfOfficeId}
                key={outOfOfficeId}
                onClick={() => onCardClick(outOfOfficeId)}
                status={status}
              />
            );
          })}
        </ChakraBox>
      </SkeletonLoader>
    </ChakraBox>
  );
};

export default OutOfOfficeScheduleList;
